import Vue from "vue"
const moment = require("moment")
require("moment/locale/it")

Vue.use(require("vue-moment"), {
  moment
})
